import Viewport from '@vaersaagod/tools/Viewport';
import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const item = dom.find('[data-item]');
    const text = dom.find('[data-text]');
    let isSmall = false;

    const onResize = () => {
        if (!isSmall && Viewport.width < 750) {
            isSmall = true;
            item.css('top', null);
        } else if (Viewport.width >= 750) {
            isSmall = false;
            const height = text.height() - item.height();
            item.css('top', `${height}px`);
        }
    };

    const init = () => {
        onResize();
        Viewport.on('resize', onResize);
    };

    const destroy = () => {
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontFeature.js